export const USER = 'USER';
export const MY_STUDIOS = 'MY_STUDIOS';
export const STUDIO = 'STUDIO';
export const CLASS_INFO = 'CLASS_INFO';
export const ERROR = 'ERROR';
export const NEED_LOGIN = 'NEED_LOGIN';
export const DOMAIN = 'DOMAIN';
export const BIRTHDAYS = 'BIRTHDAYS';
export const SELECTED_ATTENDANCE_WEEK = 'SELECTED_ATTENDANCE_WEEK';
export const SUBSCRIPTION = 'SUBSCRIPTION';
export const NAVIGATION_SETTINGS = 'NAVIGATION_SETTINGS';

export function currentBirthdays(data) {
  return { type: BIRTHDAYS, data: { birthdays: data, lastUpdate: new Date() } };
}

export function addDomain(data) {
  return { type: DOMAIN, data: data };
}
export function setSelectedAttendanceWeek(week) {
  return { type: SELECTED_ATTENDANCE_WEEK, week: week };
}

export function addUser(user) {
  return { type: USER, user: user };
}
export function addSubscription(subscription) {
  return { type: SUBSCRIPTION, subscription: subscription };
}
export function addNavigationSettings(navigationSettings) {
  return { type: NAVIGATION_SETTINGS, navigationSettings: navigationSettings };
}
export function myStudios(items) {
  return { type: MY_STUDIOS, data: { items: items } };
}
export function cleanUpMyStudios() {
  return { type: MY_STUDIOS, data: {} };
}

export function removeUser() {
  return { type: USER, user: null };
}

export function setStudio(studio) {
  localStorage.setItem('selectedStudioId', studio.id);
  return { type: STUDIO, studio: studio };
}
export function setClassInfo(classInfo) {
  return { type: CLASS_INFO, classInfo: classInfo };
}
export function unsetClassInfo() {
  return { type: CLASS_INFO, classInfo: {} };
}

export function showError(text) {
  return { type: ERROR, data: { show: true, text: text } };
}
export function hideError() {
  return { type: ERROR, data: { show: false } };
}

export function showNeedLoging() {
  return { type: NEED_LOGIN, show: true };
}
export function hideNeedLoging() {
  return { type: NEED_LOGIN, show: false };
}
